/*
 * Icon Tile — collection page toolbar.
 * The Filter button opens the facets as a full-width mega panel anchored
 * under the sticky toolbar (no drawer: the shopper stays on the page).
 * Closes on outside click / Escape. Facets.js keeps handling the actual
 * filtering via section rendering; it swaps .js-filter nodes in place, so
 * the open state of the panel survives filter changes.
 */
(function () {
  function container() {
    return document.querySelector('.body-template-collection .facets-container-main');
  }

  function setOpen(open) {
    var c = container();
    if (!c) return;
    c.classList.toggle('ico-filters-open', open);
    var btn = c.querySelector('.ico-filter-toggle');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ico-filter-toggle');
    if (btn) {
      e.preventDefault();
      var c = container();
      setOpen(!(c && c.classList.contains('ico-filters-open')));
      return;
    }
    var c = container();
    if (!c || !c.classList.contains('ico-filters-open')) return;
    // clicks inside the panel or toolbar keep it open (facet inputs re-render)
    if (!e.target.closest('.facets-container-main')) setOpen(false);
  });

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') setOpen(false);
  });

  // mark the toolbar while it is stuck; the hover breadcrumb strip only
  // shows then (the pinned breadcrumb above covers the unscrolled state)
  function watchStuck() {
    var bar = container();
    if (!bar || bar.dataset.icoStuckWatched) return;
    bar.dataset.icoStuckWatched = '1';
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    bar.parentElement.insertBefore(sentinel, bar);
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('ico-stuck', !entries[0].isIntersecting);
    }).observe(sentinel);
  }
  // Custom sort dropdown — the native <select> dropdown is browser-ugly. Build a
  // styled menu from its options, sitting OUTSIDE .facets-sorting (which the theme
  // re-renders on every AJAX filter/sort), so it survives. Picking an option sets
  // the (hidden) native #SortBy and fires an 'input' event, which the theme's
  // facet-filters-form listens to and applies via section rendering.
  function buildSort() {
    var wrap = document.querySelector('.body-template-collection .facets__sort-wrapper');
    if (!wrap || wrap.querySelector('.ico-sort')) return;
    var select = document.querySelector('.body-template-collection #SortBy');
    if (!select) return;

    var box = document.createElement('div');
    box.className = 'ico-sort';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ico-sort__btn focus-inset';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'Sort by');
    btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 6h16M6 12h12M10 18h6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
    var menu = document.createElement('ul');
    menu.className = 'ico-sort__menu';
    menu.setAttribute('role', 'listbox');
    [].forEach.call(select.options, function (opt) {
      var li = document.createElement('li');
      li.className = 'ico-sort__opt' + (opt.selected ? ' is-active' : '');
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', opt.selected ? 'true' : 'false');
      li.dataset.value = opt.value;
      li.textContent = opt.textContent.replace(/\s+/g, ' ').trim();
      menu.appendChild(li);
    });
    box.appendChild(btn);
    box.appendChild(menu);
    wrap.appendChild(box);

    function close() { box.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = box.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    menu.addEventListener('click', function (e) {
      var li = e.target.closest('.ico-sort__opt');
      if (!li) return;
      var sel = document.querySelector('.body-template-collection #SortBy');
      if (sel) {
        sel.value = li.dataset.value;
        sel.dispatchEvent(new Event('input', { bubbles: true }));
      }
      [].forEach.call(menu.children, function (c) {
        var on = c === li;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      close();
    });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) close(); });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') close(); });
  }

  function boot() { watchStuck(); buildSort(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
